import { useCallback, useState } from "react";
import { ProjectRecord } from "@/types";
import { downloadDocument } from "@/utils/downloadDocument";

export const useProjectDocument = () => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadDocument = useCallback(
    async (projectDetails: ProjectRecord) => {
      if (!projectDetails?.document_url) {
        return;
      }

      const fileName = `SDCP_Project_${projectDetails.id}_Enrollment_Agreement.pdf`;
      setIsDownloading(true);

      try {
        await downloadDocument(projectDetails.document_url, fileName);
      } catch (error) {
        throw new Error("Failed to download document. Please try again later.");
      } finally {
        setIsDownloading(false);
      }
    },
    []
  );

  const handlePreviewDocument = useCallback((projectDetails: ProjectRecord) => {
    if (projectDetails?.document_url) {
      window.open(projectDetails.document_url, "_blank");
    }
  }, []);

  return {
    handleDownloadDocument,
    handlePreviewDocument,
    isDownloading,
  };
};
